import { gql } from '@apollo/client'

export const GET_PLAYLISTS = gql`
  query GetPlaylists {
    playlistList(userCurrent: true) {
        playlists {
            id
            uid
            playlistType
            playlistName
        }
    }
}
`
export const CREATE_PLAYLIST = gql`
  mutation CreatePlaylist ($playlistName: String!) {
    playlistCreate(playlist: { playlistType: "user", playlistName: $playlistName }) {
        playlist {
            id
            uid
            playlistType
            playlistName
        }
    }
}
`

export const ADD_TO_PLAYLIST = gql`
  mutation addToPlaylist ($contentId: Int!, $contentType: String!, $playlistId: ID!, $playlistType: String!) {
    playlistCreatePlaylistItem(
        playlistItem: { contentId: $contentId, contentType: $contentType }
        playlist: { id: $playlistId, playlistType: $playlistType }
    ) {
        playlistItem {
            id
            playlistId
            contentType
            contentId
            titleGroupId
            playlistPosition
        }
    }
}
`

export const REMOVE_FROM_PLAYLIST = gql`
  mutation removeFromPlaylist ($contentId: Int!, $contentType: String!, $playlistId: ID!, $playlistType: String!) {
    playlistDeletePlaylistItem(
        playlistItem: {
            contentId: $contentId
            contentType: $contentType
        }
        playlist: { id: $playlistId, playlistType: $playlistType }
    ) {
        playlistItem {
            id
            playlistId
            contentType
            contentId
            titleGroupId
            playlistPosition
        }
    }
}
`
